<template>
  <!-- <div id="control-popup" :class="className" v-if="currentName">
    <div id="header">
      <img class="logo-img" :src="logoAddress" alt="" />
      <div class="settings-label">{{ $t(currentTabComponent) }}</div>
      <button class="close-button" @click="closeFrame">
        <img src="../../assets/icons/close.png" alt="" />
      </button>
    </div>
    <div class="control-content">
      <component :is="currentTabComponent" @closeFrame="closeFrame"></component>
    </div>
    <div class="download-wrapper mobile-only">
      <img class="logo" src="../../assets/icons/sf_logo.png" alt="Schubert & Franzke Logo" />
      <div class="download-text" v-if="project.cityapp">{{ $t("settings.downloadMsg") }}</div>
      <button v-if="project.cityapp" class="downl-img" @click="goToPlayStore()">
        <img src="../../assets/icons/robot.png" alt="" />
      </button>
      <button v-if="project.cityapp" class="downl-img" @click="goToIStore()">
        <img src="../../assets/icons/apple.png" alt="" />
      </button>
    </div>
  </div> -->

  <div v-if="currentName">
    <!-- Overlay sub popup -->
    <div class="control-overlay" aria-hidden="true" @click="closeFrame"></div>

    <!-- Popup peste overlay -->
    <div id="control-popup" :class="className">
      <div id="header">
        <img class="logo-img" :src="logoAddress" alt="" />
        <div class="settings-label">{{ $t(currentTabComponent) }}</div>
        <button class="close-button" @click="closeFrame">
          <img src="../../assets/icons/close.png" alt="" />
        </button>
      </div>

      <div class="control-content">
        <component :is="currentTabComponent" @closeFrame="closeFrame"></component>
      </div>

      <!-- <div class="download-wrapper mobile-only">
        <img class="logo" src="../../assets/icons/sf_logo.png" alt="Schubert & Franzke Logo" />
        <div class="download-text" v-if="project.cityapp">{{ $t("settings.downloadMsg") }}</div>
        <button v-if="project.cityapp" class="downl-img" @click="goToPlayStore()">
          <img src="../../assets/icons/robot.png" alt="" />
        </button>
        <button v-if="project.cityapp" class="downl-img" @click="goToIStore()">
          <img src="../../assets/icons/apple.png" alt="" />
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import M2wApi from "../../services/m2w_api";
import LayersControl from "./LayersControl";
import SettingsControl from "./SettingsControl";

export default {
  name: "ControlPopup",
  components: {LayersControl, SettingsControl},
  data() {
    return {
      isSettingsPopup: false,
      project: Vue.config.project,
      hpPushed: false,
      hpClosingByCode: false,
      onPopState: null,
    };
  },
  props: {
    currentName: String,
  },
  computed: {
    currentTabComponent: function () {
      if (this.currentName) return this.currentName + "Control";
      return null;
    },
    className: function () {
      if (this.isSettingsPopup) {
        return "settings";
      }
      return "layers";
    },
    logoAddress() {
      return M2wApi.host_address + Vue.config.project.logo;
    },
  },

  // watch: {
  //   currentName: {
  //     immediate: true,
  //     handler(v, oldV) {
  //       document.body.classList.toggle("controlpopup-open", !!v);

  //       // când se deschide
  //       if (v && !oldV) this.$root.$emit("controlPopupOpened");

  //       // când se închide
  //       if (!v && oldV) this.$root.$emit("controlPopupClosed");
  //     }
  //   }
  // },
  watch: {
    currentName: {
      immediate: true,
      handler(v, oldV) {
        document.body.classList.toggle("controlpopup-open", !!v);

        const isMobile = window.matchMedia("(max-width: 600px)").matches;

        if (v && !oldV) {
          this.$root.__controlPopupFrom = this.$route.fullPath;
          this.$root.$emit("controlPopupOpened", {from: this.$root.__controlPopupFrom});

          if (isMobile && !this.hpPushed) {
            history.pushState({m2wControlPopup: true}, "");
            this.hpPushed = true;
          }
        }

        if (!v && oldV) {
          this.$root.$emit("controlPopupClosed", {from: this.$root.__controlPopupFrom});
          this.hpPushed = false;
        }
      },
    },
  },
  mounted() {
    this.onPopState = () => {
      if (!this.currentName) return;
      if (this.hpClosingByCode) {
        this.hpClosingByCode = false;
        return;
      }
      this.closeFrame({byPopstate: true});
    };

    window.addEventListener("popstate", this.onPopState);
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.onPopState);
    document.body.classList.remove("controlpopup-open");
  },
  updated() {
    this.isSettingsPopup = this.currentName === "Settings";
  },
  methods: {
    // closeFrame() {
    //   this.$emit("closeFrame");
    // },

    async closeFrame(opts = {}) {
      const {byPopstate = false} = opts;

      const isMobile = window.matchMedia("(max-width: 600px)").matches;

      // desktop => close
      if (!isMobile) {
        this.$emit("closeFrame");
        return;
      }

      const from = this.$root.__controlPopupFrom || this.$route.fullPath;

      // detect toc-id in "from"
      let hasTocInFrom = false;
      let normalizedFrom = from;

      try {
        const u = new URL(from, window.location.origin);
        const toc = (u.searchParams.get("toc-id") || "").trim();
        hasTocInFrom = toc !== "";

        // cazul 1: scoate toc-id/parent
        if (!hasTocInFrom) {
          u.searchParams.delete("toc-id");
          u.searchParams.delete("parent");
          normalizedFrom = u.pathname + (u.search ? u.search : "");
        }
      } catch (e) {
        // ignore
      }

      this.$emit("closeFrame");
      if (normalizedFrom && normalizedFrom !== this.$route.fullPath) {
        await this.$router.replace(normalizedFrom).catch(() => {});
      }

      if (hasTocInFrom) {
        // CAZ 2
        // cats-has-toc + cats-expanded + cats-overlay-on
        this.$root.$emit("openCategoriesMenu", {forceOverlay: true});

        // extra
        this.$nextTick(() => {
          this.$root.$emit("openCategoriesMenu", {forceOverlay: true});
        });
      } else {
        // CAZ 1
        // cats-no-toc + cats-compact
        this.$root.$emit("categoriesToCompact", {overlayOnNextOpen: false});
      }

      if (!byPopstate && this.hpPushed) {
        this.hpClosingByCode = true;
        this.hpPushed = false;
        history.back();
      }

      this.$root.__controlPopupFrom = null;
    },
    goToPlayStore() {
      window.location.href = Vue.config.project.cityapp.play_store_url;
    },
    goToIStore() {
      window.location.href = Vue.config.project.cityapp.app_store_url;
    },
  },
};
</script>
